import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import Typography from '@material-ui/core/Typography';

const sanitizeRestProps = ({
  addLabel,
  allowEmpty,
  basePath,
  cellClassName,
  className,
  formClassName,
  headerClassName,
  label,
  linkType,
  locale,
  record,
  resource,
  sortable,
  sortBy,
  source,
  textAlign,
  translateChoice,
  ...rest
}) => rest;

const CompanyName = ({
  className, record = {}, users, callcenters, companies, ...rest
}) => {
  const user = users.filter(obj => obj.id === record.userId)[0];
  let companyName = 'Пользователь Удален';
  if (user) {
    switch (user.role) {
      case 'callcenter_admin':
      case 'callcenter_manager':
        companyName = callcenters.filter(obj => obj.id === user.callcenterId.$oid)[0].name;
        break;
      case 'company_admin':
      case 'company_manager':
        companyName = companies.filter(obj => obj.id === user.companyId.$oid)[0].name;
        break;
      default:
        companyName = 'Secretar';
        break;
    }
  }
  return (
    <Typography
      component="span"
      body1="body1"
      className={className}
      {...sanitizeRestProps(rest)}
    >
      {companyName}
    </Typography>
  );
};

CompanyName.propTypes = {
  addLabel: PropTypes.bool,
  basePath: PropTypes.string,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  sortBy: PropTypes.string,
};

const PureTextField = pure(CompanyName);

PureTextField.defaultProps = {
  addLabel: true,
};

export default PureTextField;



// WEBPACK FOOTER //
// ./src/components/CompanyName.js